import { BaseWebComponentDataProviderFactory } from '../../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../../webcomponents.constants';
import { CredentialsManagerGridBaseDataProvider } from '../dataProvider/CredentialsManagerGridBaseDataProvider';

export class CredentialsManagerGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, CredentialsManagerGridBaseDataProvider);
  }
}
